import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { EyeIcon, EyeOffIcon, Loader2Icon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { AkkoBadge, DistrictLogo } from '../components/BrandMark';
import { district } from '../data/district';
function GoogleMark() {
  return <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true" data-id="element-517" data-mp="2fopskbiidr3x">
      <path fill="#4285F4" d="M23.5 12.3c0-.9-.1-1.5-.2-2.2H12v4.2h6.5c-.1 1.1-.8 2.7-2.4 3.8v3h3.8c2.3-2.1 3.6-5.2 3.6-8.8z" data-id="element-518" data-mp="33f3b9bf7edlu" />
      <path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.8-3c-1 .7-2.4 1.2-4.1 1.2-3.2 0-5.9-2.1-6.8-5H1.3v3.1C3.3 21.3 7.3 24 12 24z" data-id="element-519" data-mp="38ezdb54cbuyr" />
      <path fill="#FBBC05" d="M5.2 14.3c-.2-.7-.4-1.5-.4-2.3s.1-1.6.4-2.3V6.6H1.3A11.9 11.9 0 0 0 0 12c0 1.9.5 3.8 1.3 5.4l3.9-3.1z" data-id="element-520" data-mp="2ylqybyjvzv8x" />
      <path fill="#EA4335" d="M12 4.7c1.8 0 3.3.6 4.5 1.8l3.4-3.3C17.9 1.2 15.2 0 12 0 7.3 0 3.3 2.7 1.3 6.6l3.9 3.1c.9-2.9 3.6-5 6.8-5z" data-id="element-521" data-mp="3mb340og09l6h" />
    </svg>;
}
export function Login() {
  const {
    user,
    signIn
  } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('testuser');
  const [password, setPassword] = useState('Test1234!');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  if (user) return <Navigate to="/overview" replace data-id="element-522" data-mp="3a68tqwblpqxr" />;
  function enter() {
    setLoading(true);
    setTimeout(() => {
      signIn();
      navigate('/overview');
    }, 500);
  }
  function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (!username.trim() || !password.trim()) {
      setError('Enter both your username and password to continue.');
      return;
    }
    setError('');
    enter();
  }
  return <div className="flex min-h-full w-full flex-col items-center justify-center bg-white px-4 py-12" data-id="element-523" data-mp="1ptt2j59n66ra">
      <div className="mb-8 flex flex-col items-center gap-2" data-id="element-524" data-mp="1kuowuolxer5p">
        <DistrictLogo size="lg" data-id="element-525" data-mp="2ai2oyykmfg4a" />
        <p className="text-[15px] font-bold text-ink-900" data-id="element-526" data-mp="2aiubzl05k5iy">{district.name}</p>
        <AkkoBadge tone="light" data-id="element-527" data-mp="2eiuxtqpkzj01" />
      </div>

      <div className="w-full max-w-md rounded-lg border border-ink-200 bg-white px-8 py-8 shadow-card" data-id="element-528" data-mp="2jhpfgpbtb1ik">
        <button type="button" onClick={enter} disabled={loading} className="flex h-11 w-full items-center justify-center gap-3 rounded border border-ink-300 bg-white text-[15px] font-medium text-ink-800 transition-colors hover:bg-ink-50 disabled:opacity-60" data-id="element-529" data-mp="2og96331cp1h9">
          <GoogleMark data-id="element-530" data-mp="327fbtgv83vcl" />
          Sign In with Google
        </button>

        <div className="my-5 flex items-center gap-3" data-id="element-531" data-mp="32a9w98e8lg60">
          <span className="h-px flex-1 bg-ink-200" data-id="element-532" data-mp="375p7dskv0xyq" />
          <span className="text-[13px] text-ink-400" data-id="element-533" data-mp="3c6d6l1j8sl41">or</span>
          <span className="h-px flex-1 bg-ink-200" data-id="element-534" data-mp="3c7y1wtdds82y" />
        </div>

        <form onSubmit={onSubmit} noValidate data-id="element-535" data-mp="3h69az1vuqek4">
          <label htmlFor="username" className="block text-[14px] text-ink-800" data-id="element-536" data-mp="3h33hzbk3qsj4">
            Username
          </label>
          <input id="username" type="text" autoComplete="username" value={username} onChange={e => setUsername(e.target.value)} placeholder="Enter your Username" className="mt-2 h-11 w-full rounded border border-ink-300 px-3 text-[14px] text-ink-900 placeholder:text-ink-400 focus:border-brand-500 focus:outline-none" data-id="element-537" data-mp="10irm8dlcmjwx" />

          <label htmlFor="password" className="mt-5 block text-[14px] text-ink-800" data-id="element-538" data-mp="1j8psco5l62xx">
            Password
          </label>
          <div className="mt-2 flex" data-id="element-539" data-mp="1eh7zyohmpaok">
            <input id="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter your Password" className="h-11 w-full rounded-l border border-r-0 border-ink-300 px-3 text-[14px] text-ink-900 placeholder:text-ink-400 focus:border-brand-500 focus:outline-none" data-id="element-540" data-mp="1eg6bniblqrow" />
            <button type="button" onClick={() => setShowPassword(v => !v)} aria-label={showPassword ? 'Hide password' : 'Show password'} className="flex h-11 w-12 items-center justify-center rounded-r border border-ink-300 text-ink-700 hover:bg-ink-50" data-id="element-541" data-mp="1rqhzkxj2m7or">
              {showPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-542" data-mp="2afeu92idr27i" /> : <EyeIcon className="h-5 w-5" data-id="element-543" data-mp="2aed7w1vwytah" />}
            </button>
          </div>

          {error && <p role="alert" className="mt-3 text-[13px] text-red-600" data-id="element-544" data-mp="1vq8y5neu9s3u">
              {error}
            </p>}

          <button type="submit" disabled={loading} className="mt-5 flex h-11 w-full items-center justify-center gap-2 rounded bg-brand-600 text-[15px] font-bold text-white transition-colors hover:bg-brand-700 disabled:opacity-70" data-id="element-545" data-mp="20nsc0m7mk2v9">
            {loading && <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-546" data-mp="hpckvnqi8tpg" />}
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="mt-6 text-center" data-id="element-547" data-mp="rgqmq25xi5lr">
          <Link to="/forgot-password" className="text-[13px] text-ink-800 underline-offset-2 hover:underline" data-id="element-548" data-mp="rggyok4g28ip">
            Forgot your password?
          </Link>
        </p>
      </div>

      <p className="mt-6 text-[12px] text-ink-400" data-id="element-549" data-mp="3uys698krd4rr">
        Prototype — credentials are pre-filled, just press <span className="font-semibold" data-id="element-550" data-mp="3pzxli138d650">Sign in</span>.
      </p>
    </div>;
}